import React, { useEffect, useRef, useState } from "react";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
  ModalProgressBar,
} from "../../../../../../_metronic/_partials/controls";
import { useSubheader } from "../../../../../../_metronic/layout";
import { shallowEqual, useDispatch, useSelector } from "react-redux";

import * as actions from "../../../_redux/investigations/investigationsActions";
import InvestigationEditForm from "./InvestigationEditForm";
import { toast } from "react-hot-toast";

export function InvestigationEdit({
  history,
  match: {
    params: { id },
  },
}) {
  const backToInvestigationsList = () => {
    history.push(`/qc/investigations/${id}`);
  };

  const subHeader = useSubheader();

  const [title, setTitle] = useState("");
  const dispatch = useDispatch();

  const { actionsLoading, investigationToView } = useSelector(
    (state) => ({
      actionsLoading: state.investigations.actionsLoading,
      investigationToView: state.investigations.investigationToView,
    }),
    shallowEqual
  );

  useEffect(() => {
    dispatch(actions.fetchInvestigation(id));
  }, [id, dispatch]);

  useEffect(() => {
    let _title = `ویرایش بازرسی شعبه ${investigationToView?.branchName ?? ""}`;
    setTitle(_title);

    subHeader.setTitle(_title);
  }, [investigationToView, id]);

  const saveInvestigation = (values) => {
    dispatch(actions.updateInvestigation(values))
      .then(() => {
        backToInvestigationsList();
        toast.success("بازرسی با موفقیت تغییر کرد");
      })
      .catch(() => {
        toast.error("خطا در تغییر بازرسی");
      });
  };

  const btnRef = useRef();

  const saveInvestigationClick = () => {
    if (btnRef && btnRef.current) {
      btnRef.current.click();
    }
  };

  return (
    <Card>
      {actionsLoading && <ModalProgressBar />}
      <CardHeader title={title}>
        <CardHeaderToolbar>
          <button
            type={"button"}
            onClick={backToInvestigationsList}
            className={"btn btn-light"}
          >
            <i className={"fa fa-arrow-left"} />
            برگشت
          </button>
          <> </>
          <button
            type={"button"}
            className={"btn btn-primary ml-2"}
            onClick={saveInvestigationClick}
          >
            ذخیره
          </button>
        </CardHeaderToolbar>
      </CardHeader>
      <CardBody>
        <InvestigationEditForm
          investigation={investigationToView}
          btnRef={btnRef}
          saveInvestigation={saveInvestigation}
        />
      </CardBody>
    </Card>
  );
}
